import VcomProvider from '../../../../VcomProvider';
function makeMeasurementTermUrl(systemId) {
    return `${VcomProvider.baseUrl}/../../ssp/term/dataAnalysis.php?systemId=${systemId}`;
}
export default {
    makeMeasurementTermUrl,
};
